import './gravityforms.scss';
import TomSelect from 'tom-select';
import { focusAndOpenKeyboard } from '../helpers/helpers';

$(document.body).on('submit', '.form--gravity', (event) => {
    const target = $(event.currentTarget);
    const button = target.find('.gform_footer .button');

    target.addClass('is-loading');

    if (!button.parent().find('.loader').length) {
        $('<div class="loader"></div>').insertAfter(button);
    }
});

let tomSelectInstances = [];

$(document).on('gform_post_render', () => {
    // Destroy existing instances
    tomSelectInstances.forEach((instance) => {
        if (instance) {
            instance.destroy();
        }
    });
    tomSelectInstances = [];

    document.querySelectorAll('select').forEach((select) => {
        const ts = new TomSelect(select, {
            plugins: ['dropdown_input'],
            render: {
                no_results: null, // eslint-disable-line camelcase
                loading: () => '<div class="loading">Loading...</div>',
            },
            onInitialize() {
                this.control_input.setAttribute('placeholder', window.ballers.text.search);

                const searchInput = this.dropdown.querySelector('.ts-dropdown-input');

                if (searchInput) {
                    searchInput.placeholder = window.ballers.text.search;
                }

                this.control_input.classList.add('ts-custom-search');
            },
        });

        tomSelectInstances.push(ts);
    });
});

$(document).on('gform_confirmation_loaded', (event, formID) => {
    const confirmationWrapper  = $(`[id="gform_confirmation_wrapper_${formID}"]`);
    const twoColumnsFormColumn = confirmationWrapper.closest('.two-columns__item--form');

    if (twoColumnsFormColumn.length) {
        twoColumnsFormColumn.find('> *:not(.gform_anchor):not(.gform_confirmation_wrapper):not(script):not(iframe)').remove();
    }
});

if (typeof gform !== 'undefined') {
    gform.addAction('gform_post_conditional_logic_field_action', (formId, action, targetId) => { // eslint-disable-line no-undef
        if (action !== 'show') {
            return formId;
        }

        focusAndOpenKeyboard($(targetId).find('[name]'), 400);
    });
}
